module.exports = __webpack_public_path__ + "static/media/capJ1_2024.fa0b4eff.png";